import * as React from 'react'
import { RouteComponentProps } from 'react-router'
import TableToggle from './TableToggle'
import VehiclesTable from '../../containers/vehicles/VehiclesTable'
import VehiclesFilter from '../../containers/vehicles/VehicleFilter'
import VehicleSearch from '../../containers/vehicles/VechicleSearch'
import { IVehicleFilters } from '../../types'
import { Button } from '@mobiscroll/react-latest'

export interface IVehiclesListProps extends RouteComponentProps<any> {
  updateVehicleFilters: (params: IVehicleFilters) => Promise<any>
  showFilter: boolean
  list: string
  currentOrgId: string
}

// export interface IVehiclesListState extends RouteComponentProps {
//   isLoading: boolean
// }

class VehiclesList extends React.Component<IVehiclesListProps> {
  // constructor(props: any) {
  //   super(props)
  //   this.state = {
  //     isLoading: false
  //   }
  // }

  public componentDidMount() {
    const { currentOrgId, list } = this.props
    const filterPayload: IVehicleFilters = { organizationId: '', type: '' }
    if (currentOrgId && list) {
      filterPayload.type = list
      filterPayload.organizationId = currentOrgId
      this.props.updateVehicleFilters(filterPayload)
    }
  }

  public render() {
    const ROUTES = {
      CREATE_VEHICLE: `${this.props.match.path}create/personal-info`
    } as const

    const createVehicle = () => {
      this.props.history.push(ROUTES.CREATE_VEHICLE)
    }

    return (
      <div className='pt2'>
        <div className='flex justify-between'>
          <TableToggle
            selected={this.props.list}
            history={this.props.history}
            location={this.props.location}
            match={this.props.match}
          />
          <div className='flex flex-row'>
            <VehicleSearch type={this.props.list} />
            <Button className='mobiscroll-green-btn' onClick={createVehicle}>
              <span className='font-white'>+ Create New Vehicle</span>
            </Button>
          </div>
        </div>
        {this.props.showFilter && <VehiclesFilter />}
        <VehiclesTable list={this.props.list} />
      </div>
    )
  }
}

export default VehiclesList



// WEBPACK FOOTER //
// ./src/components/vehicles/VehiclesList.tsx